import { API_ENDPOINTS } from "../../../../Api/apiEndPoints";
import axiosInstance from "../../../../Api/axiosInstance";

export const getOrgUitList = async (params: any) => {
  let response = await axiosInstance.get(API_ENDPOINTS.SETTING.GET_ORG_UNIT_LIST, {params});
  const rowData = response?.data;
  const formateData = Array.isArray(rowData?.data?.data)
    ? rowData.data.data.map((item: any) => ({
        UnitName: item.UnitName || "-",
        Scountry: item.GeoCountryData?.Scountry || "-",  // ✅ fixed
        CanDoCustomPlaylist: item.CanDoCustomPlaylist ? "True" : "False",
        IsExposed: item.IsExposed ? "Yes" : "No",
        CurrencyId: item.CurrencyId || '-',
        CountryId: item.CountryId || '-',
        PunchinOnHoliday: item.PunchinOnHoliday ? 1 : 0,
        PunchinOnLeave: item.PunchinOnLeave ? 1 : 0,
        PunchinOnWeekoff: item.PunchinOnWeekoff ? 1 : 0,
        OrgunitAdminPosition: item.OrgunitAdminPosition || '-',  
        PositionName: item.PositionData?.PositionName || '-',   // ✅ safe lookup
        Orgunitid: item.Orgunitid || '-',
        EmployeeId:item.EmployeeId || '-'
      }))
    : [];

  return { formateData, rowData };
};


export const getCountryList = async () => {
  let response = await axiosInstance.get(
    API_ENDPOINTS.SETTING.GET_COUNTRY_LIST
  );
  const rowData = response?.data;
  const formateData = Array.isArray(rowData?.data?.data)
    ? rowData?.data?.data.map((item: any) => ({
        id: item.Icountryid || "-",
        label: item.Scountry || "-",
      }))
    : [];
  return { formateData, rowData };
};

export const addOrgUnit = async (ReqBody: any) => {
  const url = API_ENDPOINTS.SETTING.POST_ADD_ORG_UNIT;
  let response = await axiosInstance.post(url, ReqBody);
};


export const update_OrgUnit = async(ReqBody:any,id:number)=>{
       let url = API_ENDPOINTS.SETTING.PUT_UPDATE_ORG_UNIT;
       let response = await axiosInstance.put(`${url}/${id}`,ReqBody); 
}

export const getUserConfig = async () => {
  let response = await axiosInstance.get(API_ENDPOINTS.SETTING.GET_USER_CONFIG);

  const rowData = await response?.data;
  const Is_Exposed = Array.isArray(response?.data?.data?.exposed)
    ? response?.data?.data?.exposed.map((item: any, index: number) => ({
        id: index,
        label: item,
      }))
    : [];

  const Can_Do_Custom_Playlistposed = Object.entries(
    response?.data?.data?.status || {}
  ).map(([key, value]) => ({
    id: key,
    label: String(value),
  }));
  return { Is_Exposed, Can_Do_Custom_Playlistposed, rowData };
};

// GET_BRANCH_LIST
export const getBranchList = async (params: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.SETTING.GET_BRANCH_LIST,
    { params: params }
  );

  console.log(
    "🚀 ~ SettingsMastersRepo.ts:69 ~ getBranchList ~ response:",
    response
  );

  return response?.data;
};

// ADD_BRANCH
export const addBranch = async (body: any) => {
  const url = `${API_ENDPOINTS.SETTING.ADD_BRANCH}`;
  let response = await axiosInstance.post(url, body);
  console.log("🚀 ~ SettingRepo.ts:34 ~ addBranch ~ response:", response);
};

export const updateBranch = async (id?: string | number, body?: any) => {
  return axiosInstance.post(
    `${API_ENDPOINTS.SETTING.UPDATE_BRANCH}/${id}`,
    body
  );
};

// GET_DESIGNATION
export const getDesignationList = async (params: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.SETTING.GET_DESIGNATION,
    { params: params }
  );

  console.log(
    "🚀 ~ SettingsMastersRepo.ts:98 ~ getDesignationList ~ response:",
    response
  );

  return response?.data;
};

export const getDesignationColorsList = async () => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.SETTING.GET_DESIGNATIONS_COLOR
  );

  console.log(
    "🚀 ~ SettingsMastersRepo.ts:111 ~ getDesignationColorsList ~ response:",
    response?.data?.data
  );

  return response?.data;
};

// ADD_DESIGNATION

export const addDesignation = async (body: {
  designationName: string | number;
  designationColor: string | number;
}) => {
  return axiosInstance.post(API_ENDPOINTS.SETTING.ADD_DESIGNATION, body);
};

// UPDATE_DESIGNATION
export const updateDesignation = async (body?: any) => {
  return axiosInstance.put(`${API_ENDPOINTS.SETTING.UPDATE_DESIGNATION}`, body);
};

// GET_OUTLET_TYPE_LIST
export const getOutletTypeList = async () => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.SETTING.GET_OUTLET_TYPE_LIST
  );

  console.log(
    "🚀 ~ SettingsMastersRepo.ts:139 ~ getOutletTypeList ~ response:",
    response
  );

  return response?.data;
};

// ADD_OUTLET_TYPES

export const addOutletTypes = async (body?: any) => {
  return axiosInstance.post(API_ENDPOINTS.SETTING.ADD_OUTLET_TYPES, body);
};

// UPDATE_OUTLET_TYPES
export const updateOutletType = async (id?: string | number, body?: any) => {
  return axiosInstance.put(
    `${API_ENDPOINTS.SETTING.UPDATE_OUTLET_TYPES}/${id}`,
    body
  );
};

// GET_OUTLET_TYPES_MODULE

export const getOutletTypeModuleList = async (
  id?: string | number,
  params?: any
) => {
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.SETTING.GET_OUTLET_TYPES_MODULE}/${id}`,
    { params: params }
  );

  console.log(
    "🚀 ~ SettingsMastersRepo.ts:172 ~ getOutletTypeModuleList ~ response:",
    response
  );

  return response?.data;
};

// ADD_OUTLET_TYPES_MODULE
export const addOutletTypesModules = async (body?: any) => {
  return axiosInstance.post(
    API_ENDPOINTS.SETTING.ADD_OUTLET_TYPES_MODULE,
    body
  );
};

// UPDATE_OUTLET_TYPES_MODULE
export const updateOutletTypeModule = async (id?: string | number, body?: any) => {
  return axiosInstance.put(
    `${API_ENDPOINTS.SETTING.UPDATE_OUTLET_TYPES_MODULE}/${id}`,
    body
  );
};